import { RigidBody, vec3 } from "@react-three/rapier";
import { isHost } from "playroomkit";
import { useEffect, useRef } from "react";
import { MeshBasicMaterial } from "three";
import { WEAPON_OFFSET } from "./CharacterController";

// let WEAPON_OFFSET_W = {};

// const BULLET_SPEED = 1;
const BULLET_SPEED = 20;

const bulletMaterial = new MeshBasicMaterial({
  color: "hotpink",
  toneMapped: false,
});

bulletMaterial.color.multiplyScalar(42);

export const Bullet = ({ player, angle, position, onHit, origin }) => {
  const rigidbody = useRef();

  // if (origin === 'K') {
  //   WEAPON_OFFSET_W = WEAPON_OFFSET_K;
  // } else {
  //   WEAPON_OFFSET_W = WEAPON_OFFSET;
  // }

  useEffect(() => {
    const audio = new Audio("/audios/kick.mp3");
    audio.play();
    const velocity = {
      x: Math.sin(angle) * BULLET_SPEED,
      y: 30,
      z: Math.cos(angle) * BULLET_SPEED,
    };
    rigidbody.current.setLinvel(velocity, true);
  }, []);

  return (
    <group position={[position.x, position.y, position.z]} rotation-y={angle}>
      <group
        position-x={WEAPON_OFFSET.x}
        position-y={WEAPON_OFFSET.y}
        position-z={WEAPON_OFFSET.z}
      >
        <RigidBody
          ref={rigidbody}
          name="bullet"
          gravityScale={0}
          onIntersectionEnter={(e) => {
            if (isHost() && e.other.rigidBody.userData?.type !== "bullet") {
              rigidbody.current.setEnabled(false);
              onHit(vec3(rigidbody.current.translation()));
            }
          }}
          sensor
          userData={{
            type: "bullet",
            player,
            damage: 10,
          }}
        >
          <mesh position-z={0.25} material={bulletMaterial} castShadow>
            <boxGeometry args={[0.5, 0.5, 0.5]} />
          </mesh>
        </RigidBody>
      </group>
    </group>
  );
};